<script lang="ts">
  interface Props {
    respawnSeconds: number;
    returnToMenuRequested: boolean;
    tip: string;
  }

  const { respawnSeconds, returnToMenuRequested, tip }: Props = $props();
</script>

<div class="death" role="status">
  <p class="death__heading">Respawn in {respawnSeconds} seconds.</p>
  {#if !returnToMenuRequested}
    <p class="death__hint">Press esc to return to the main menu.</p>
  {/if}
</div>
{#if tip !== ''}
  <p class="death-tip">Tip: {tip}</p>
{/if}

<style>
  .death {
    position: absolute;
    top: 96px;
    left: 0;
    width: 100%;
    text-align: center;
  }

  .death__heading {
    margin: 0;
    font-size: 30px;
    color: #fff;
  }

  .death__hint {
    margin: 8px 0 0;
    font-size: 14px;
    color: #fff;
  }

  .death-tip {
    position: absolute;
    bottom: 148px;
    left: 0;
    width: 100%;
    margin: 0;
    padding: 0 60px;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }
</style>
